var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"focus-section",rawName:"v-focus-section"}]},[_c('Sidebar'),(_vm.isMobile)?_c('MobileMenu',{ref:"mobileMenu"}):_vm._e(),_c('router-view',{staticClass:"pl-12",attrs:{"status":_vm.status}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }